import React from "react";
import {
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";

function PropertyTypeMobile() {
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,
    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "propertyType" });
  const props = useCurrentRefinements();
  //console.log(props.items, props.canRefine, props.createURL)
  const itemRefs = props.items;
  const arr = itemRefs.find((c) => c.attribute === "propertyType");
  return (
    <div className=" grid grid-cols-3 gap-4">
      {items?.map((item) => {
        const exists = arr?.refinements.find(
          (el) => el.value === item.value
        )?.value;
        return (
          <div
            onClick={() => {
              refine(item.value);
            }}
            key={item.value}
            className={
              " flex  h-20 cursor-pointer items-center justify-center rounded-md" +
              (exists
                ? " border border-ula-blue bg-blue-50 text-ula-primary"
                : " border border-gray-400")
            }
          >
            <span className="  flex   select-none px-5 text-center text-gray-800">
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default PropertyTypeMobile;
